import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { SECTIONS } from '../data/profile';
import { SectionHeading } from './SectionHeading';
export function SectionDirectory() {
  return <section aria-labelledby="directory-heading" className="w-full border-t border-slateink-300/60 bg-white" data-id="element-269" data-mp="10kmah1f49jwz">
      <div className="mx-auto max-w-content px-6 py-24 sm:py-28 lg:px-8" data-id="element-270" data-mp="1agfvl96wilqd">
        <div id="directory-heading" data-id="element-271" data-mp="15huvravka42g">
          <SectionHeading eyebrow="Section Directory" title="Ten Sections of the Board Portfolio" description="Every section of this portfolio is listed openly below — nothing is buried. Each page carries only the material that belongs to it." data-id="element-272" data-mp="15gta6cgx5z6h" />
        </div>

        <ul className="mt-14 grid grid-cols-1 gap-px border border-slateink-300/70 bg-slateink-300/70 md:grid-cols-2" data-id="element-273" data-mp="3l9s7ryu30jc6">
          {SECTIONS.map((section, i) => <motion.li key={section.index} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: i % 4 * 0.05
        }} className="bg-white" data-id="element-274" data-mp="1pzngbte0elay" data-mpi={i}>
              <Link to={section.to} className="group flex h-full items-start gap-6 p-7 transition-colors hover:bg-slateink-100 sm:p-8" data-id="element-275" data-mp="24pbfop2mr9w1">
                <span className="font-serif text-lg text-gold-600" data-id="element-276" data-mp="2doexlpq29j8y">{section.index}</span>
                <span className="flex-1" data-id="element-277" data-mp="2ioaw59fzoih4">
                  <span className="flex items-start justify-between gap-4" data-id="element-278" data-mp="2iokm4x11apmt">
                    <span className="font-serif text-lg leading-snug text-navy-900 sm:text-xl" data-id="element-279" data-mp="2nm2w8qqsfawe">
                      {section.label}
                    </span>
                    <ArrowUpRightIcon className="mt-1 h-4 w-4 flex-none text-slateink-500 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-600" aria-hidden="true" data-id="element-280" data-mp="t93b6i3n1ohq" />
                  </span>
                  <span className="mt-3 block text-sm leading-relaxed text-slateink-600" data-id="element-281" data-mp="v6l60lu1t4l7">
                    {section.summary}
                  </span>
                </span>
              </Link>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}